<template>
  <BaseLayout>
    <template #fluid>
      <div class="tw-flex tw-flex-col tw-w-full">
        <Carousel />
        <div>
          <div v-if="!$screen.md">
            <mobile-tab-view />
            <mobile-scheme-view />
            <WeCanDo />
            <mobile-platform-view />
            <KnowDynamic />
          </div>
          <div v-else>
            <TabView />
            <SchemeView />
            <WeCanDo />
            <PlatformView />
            <OpeningSteps />
            <KnowDynamic />
          </div>
        </div>
      </div>
    </template>
    <!-- 春节放假通知 -->
    <!-- <NoticeModal
      :visible="showNoticeModal"
      :noticeId="currentNoticeId"
      @close="showNoticeModal = false"
    /> -->
    <!-- 活动通知 -->
    <PushModal
      :show="showActivityModal"
      :item="activityDetail"
      @close="showActivityModal = false"
    ></PushModal>
  </BaseLayout>
</template>

<script>
import TabView from "./homeViews/tabViewNew.vue";
import SchemeView from "./homeViews/schemeView.vue";
import PlatformView from "./homeViews/platformViewNew.vue";
import TransformView from "./homeViews/transformView.vue";
import Carousel from "@/layout/aside/carousel.vue";
import BaseLayout from "@/layout/BaseLayout.vue";
import WeCanDo from "./homeViews/WeCanDo.vue";
import MobileTabView from "./homeViews/mobileTabView.vue";
import MobilePlatformView from "./homeViews/mobilePlatformView.vue";
import MobileSchemeView from "./homeViews/mobileSchemeView.vue";
import OpeningSteps from "./homeViews/openingSteps.vue";
import KnowDynamic from "./homeViews/knowDynamic.vue";
import NoticeModal from "@/components/NoticeModal.vue";
import PushModal from "@/components/PushModel.vue";
import { getReadStatus } from "@/api/personalCenter/index";

export default {
  name: "HomeView",
  components: {
    TabView,
    SchemeView,
    PlatformView,
    TransformView,
    Carousel,
    BaseLayout,
    WeCanDo,
    MobileTabView,
    MobilePlatformView,
    MobileSchemeView,
    OpeningSteps,
    KnowDynamic,
    NoticeModal,
    PushModal,
  },
  watch: {
    "$screen.width"() {
      console.log("width", this.$screen.md);
    },
  },
  data() {
    return {
      setInt: null,
      tabViewKey: 882912,
      platformViewKey: 434343,
      transformViewKey: 234234,
      showNoticeModal: false,
      currentNoticeId: null,
      showActivityModal: false,
      indexInfo: {},
      // 活动信息
      activityDetail: {},
    };
  },
  beforeCreate() {
    // 如果路由有参数clearCache 则清空缓存
    if (this.$route.query.clearCache) {
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      // 二次验证->未验证
      this.$store.commit("SET_VERIFICATION", "0");
      this.$router.push("/");
      // 刷新一下
      window.location.reload();
    }
  },
  created() {
    setTimeout(() => {
      this.getData();
    }, 500);
    // const userInfo = localStorage.getItem("userInfo");
    // const isLoggedIn = !!userInfo;
    // if (isLoggedIn) {
    //   // 登录状态：调用接口获取公告
    //   this.checkAndShowNotice();
    // } else {
    //   // 未登录状态：直接显示弹窗
    //   this.showNoticeModal = true;
    //   this.currentNoticeId = null;
    // }
  },
  computed: {},

  beforeDestroy() {},
  mounted() {
    this.setInt = setInterval(() => {
      this.checkCacheAndUpdateKey();
    }, 1000);
  },
  beforeDestroy() {
    // 在组件销毁时清理定时器
    if (this.setInt) {
      clearInterval(this.setInt);
      this.setInt = null;
    }
  },

  methods: {
    getData() {
      this.indexInfo = JSON.parse(localStorage.getItem("indexInfo"));
      this.activityDetail = this.indexInfo?.activity;
      if (this.activityDetail) {
        this.showActivityModal = true;
      }
    },
    checkCacheAndUpdateKey() {
      if (this.indexInfo) {
        this.tabViewKey++;
        this.platformViewKey++;
        this.transformViewKey++;
        clearInterval(this.setInt);
        this.setInt = null;
      }
    },
    async checkAndShowNotice() {
      try {
        let id = 29;
        const { code, data } = await getReadStatus(id);
        if (code === 0 && data) {
          // 如果 isRead 为 false，显示公告
          if (data.isRead === false) {
            this.currentNoticeId = id || null;
            this.showNoticeModal = true;
          }
        }
      } catch (error) {
        console.error("获取公告失败:", error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.mt-50 {
  margin-top: 80px;
}
</style>
